// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.111.1_postcss@8.5.30_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
ul[role='list'],
ol[role='list'] {
  list-style: none;
}

/* Set core root defaults */
html:focus-within {
  scroll-behavior: smooth;
}
.msger {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 20px 10px;
  border-radius: 20px; 
}

.msger-header {
  display: flex;
  padding: 21px;
  border-bottom: var(--border);
  background: #fff;
  color: #333;
  font-size: 18px;
  font-weight: 555;
  border-radius: 20px 20px 0 0;
}

.msger-chat {
  flex: 1 1;
  overflow-y: auto;
  padding: 15px;
  background-color: #eefafd;
  max-height: 65vh;
  height: 65vh;
}
.msger-chat::-webkit-scrollbar {
  width: 6px;
}
.msger-chat::-webkit-scrollbar-track {
  background: #ddd;
}
.msger-chat::-webkit-scrollbar-thumb {
  background: #bdbdbd;
}
.msg {
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
}
.msg:last-of-type {
  margin: 0;
}
.msg-img {
  width: 50px;
  height: 50px;
  margin-right: 10px;
  background: #ddd;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 50%;
}
.msg-bubble {
  max-width: 450px;
  padding: 15px;
  border-radius: 15px;
  background: var(--left-msg-bg);
}
.msg-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.msg-info-name {
  margin-right: 10px;
  font-weight: bold;
}
.msg-info-time {
  font-size: 0.85em;
}

.left-msg .msg-bubble {
  border-bottom-left-radius: 0;
}

.right-msg {
  flex-direction: row-reverse;
}
.right-msg .msg-bubble {
  background: var(--right-msg-bg);
  color: #fff;
  border-bottom-right-radius: 0;
}
.right-msg .msg-img {
  margin: 0 0 0 10px;
}

.msger-inputarea {
  display: flex;
  padding: 10px;
  background: #fff;
  border-radius: 0 0 20px 20px;
}
.msger-inputarea * {
  padding: 10px;
  border: none;
  border-radius: 3px;
  font-size: 1em;
}
.msger-input {
  flex: 1 1;
  background: #ddd;
}
.msger-send-btn {
  margin-left: 10px;
  background: #81f2e2;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
}
.msger-send-btn:hover {
  background: #27b6a3;
}`, "",{"version":3,"sources":["webpack://./src/pages/Message/message.css"],"names":[],"mappings":"AAAA,2GAA2G;AAC3G;;EAEE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,+BAA+B;EAC/B,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,SAAO;EACP,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB","sourcesContent":["/* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */\nul[role='list'],\nol[role='list'] {\n  list-style: none;\n}\n\n/* Set core root defaults */\nhtml:focus-within {\n  scroll-behavior: smooth;\n}\n.msger {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin: 20px 10px;\n  border-radius: 20px; \n}\n\n.msger-header {\n  display: flex;\n  padding: 21px;\n  border-bottom: var(--border);\n  background: #fff;\n  color: #333;\n  font-size: 18px;\n  font-weight: 555;\n  border-radius: 20px 20px 0 0;\n}\n\n.msger-chat {\n  flex: 1;\n  overflow-y: auto;\n  padding: 15px;\n  background-color: #eefafd;\n  max-height: 65vh;\n  height: 65vh;\n}\n.msger-chat::-webkit-scrollbar {\n  width: 6px;\n}\n.msger-chat::-webkit-scrollbar-track {\n  background: #ddd;\n}\n.msger-chat::-webkit-scrollbar-thumb {\n  background: #bdbdbd;\n}\n.msg {\n  display: flex;\n  align-items: flex-end;\n  margin-bottom: 10px;\n}\n.msg:last-of-type {\n  margin: 0;\n}\n.msg-img {\n  width: 50px;\n  height: 50px;\n  margin-right: 10px;\n  background: #ddd;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  border-radius: 50%;\n}\n.msg-bubble {\n  max-width: 450px;\n  padding: 15px;\n  border-radius: 15px;\n  background: var(--left-msg-bg);\n}\n.msg-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n.msg-info-name {\n  margin-right: 10px;\n  font-weight: bold;\n}\n.msg-info-time {\n  font-size: 0.85em;\n}\n\n.left-msg .msg-bubble {\n  border-bottom-left-radius: 0;\n}\n\n.right-msg {\n  flex-direction: row-reverse;\n}\n.right-msg .msg-bubble {\n  background: var(--right-msg-bg);\n  color: #fff;\n  border-bottom-right-radius: 0;\n}\n.right-msg .msg-img {\n  margin: 0 0 0 10px;\n}\n\n.msger-inputarea {\n  display: flex;\n  padding: 10px;\n  background: #fff;\n  border-radius: 0 0 20px 20px;\n}\n.msger-inputarea * {\n  padding: 10px;\n  border: none;\n  border-radius: 3px;\n  font-size: 1em;\n}\n.msger-input {\n  flex: 1;\n  background: #ddd;\n}\n.msger-send-btn {\n  margin-left: 10px;\n  background: #81f2e2;\n  color: #fff;\n  font-weight: bold;\n  cursor: pointer;\n}\n.msger-send-btn:hover {\n  background: #27b6a3;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
